// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n.dialer-keypad[data-v-f92154a2]{\n  display:grid;\n  gap:8px;\n  grid-template-columns:repeat(3,1fr)\n}\n.dialer-keypad__key[data-v-f92154a2]{\n  background:#f4f4f6;\n  border-radius:8px;\n  font-size:20px;\n  height:44px\n}\n.dialer-keypad__key[data-v-f92154a2]:hover{\n  background:#e8e8ec\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
